var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 8.70968 15.2903 6 12 6C8.68548 6 6 8.70968 6 12C6 15.3145 8.68548 18 12 18C15.2903 18 18 15.3145 18 12ZM12.1452 7.98387C13.5242 7.98387 14.9758 9.04839 14.9758 10.4516C14.9758 12.3387 12.9677 12.3629 12.9677 13.0403V13.0645C12.9677 13.2339 12.8226 13.3548 12.6774 13.3548H11.3226C11.1532 13.3548 11.0323 13.2339 11.0323 13.0645V12.9677C11.0323 11.9758 11.7823 11.5887 12.3387 11.2742C12.8226 11.0081 13.1371 10.8145 13.1371 10.4516C13.1371 9.96774 12.5081 9.65323 12.0242 9.65323C11.371 9.65323 11.0806 9.96774 10.6452 10.5242C10.5484 10.6452 10.3548 10.6694 10.2339 10.5726L9.3871 9.94355C9.26613 9.84677 9.24194 9.67742 9.33871 9.53226C9.99194 8.54032 10.8387 7.98387 12.1452 7.98387ZM12 13.9839C12.6048 13.9839 13.1129 14.4919 13.1129 15.0968C13.1129 15.7258 12.6048 16.2097 12 16.2097C11.371 16.2097 10.8871 15.7258 10.8871 15.0968C10.8871 14.4919 11.371 13.9839 12 13.9839Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.aee809f925917407b7aeb13e818aa1d3.svg";
export { ForwardRef as ReactComponent };